const initialState = {
  selectedItem: null,
  selectedItemLoading: 'idle',

  list: [],
  loading: 'idle',
};

export default initialState;
